<div class="mdc-dialog__container">
  <div class="mat-mdc-dialog-surface mdc-dialog__surface">
    <ng-template cdkPortalOutlet></ng-template>
  </div>
</div>



// WEBPACK FOOTER //
// ../../../../../src/material/dialog/dialog-container.html